import { action, makeAutoObservable, observable } from 'mobx';

import { api } from '@/api';

import { DEFAULT_ITEMS_PER_PAGE } from '@/constants';

export class SettingsStore {
  @observable itemsPerPage: number = DEFAULT_ITEMS_PER_PAGE;

  constructor() {
    makeAutoObservable(this);
  }

  @action setSettings = (settings: cyrian.api.settings.SettingsParams) => {
    this.itemsPerPage = Number(settings.items_per_page) || DEFAULT_ITEMS_PER_PAGE;
  };

  loadSettings = async () => {
    await api.settings
      .get()
      .source.then(({ data }) => this.setSettings(data))
      .catch();
  };

  changeItemsPerPage(itemsPerPage: number | string) {
    const num = Number(itemsPerPage) || DEFAULT_ITEMS_PER_PAGE;
    api.settings
      .set({
        key: 'items_per_page',
        value: num,
      })
      .source.then((resp) => {
        if (resp.success) {
          this.setSettings({ items_per_page: num });
        }
      });
  }
}
